import { formatDate } from '@angular/common';

import { LocationInfo } from '@shared/models/location-info';
import { isTruthy } from '@shared/utils';

export interface Experience {
  id: number;
  externalId: string;
  linkedInId: number;
  employerName: string;
  jobTitle: string;
  salary: number;
  telephone: string;
  jobSummary: string;
  contactEmployer: number;
  startDate: any;
  endDate: any;
  createdDate?: any;
  lastModifiedDate?: any;
  title?: string;
  period?: string;
  jobLocation?: LocationInfo;
}

export interface ExperienceOverview {
  type: string;
  text: string;
}

export class ExperienceAdapter {
  constructor(public source?: Partial<Experience>) {}

  private get start(): string {
    return (
      !!this.source &&
      !!this.source.startDate &&
      formatDate(this.source.startDate, 'shortDate', 'en-US')
    );
  }
  private get end(): string {
    return (
      (!!this.source &&
        !!this.source.endDate &&
        formatDate(this.source.endDate, 'shortDate', 'en-US')) ||
      'Present'
    );
  }

  get id(): number {
    return !!this.source && this.source.id;
  }

  get lastModifiedDate(): any {
    return !!this.source && this.source.lastModifiedDate;
  }

  get jobTitle(): string {
    return !!this.source && this.source.jobTitle;
  }
  get employerName(): string {
    return !!this.source && this.source.employerName;
  }
  get title(): string {
    return [this.jobTitle, this.employerName].filter(isTruthy).join(' at ');
  }
  get period(): string {
    return [this.start, this.end].filter(isTruthy).join(' - ');
  }
  get jobSummary(): string {
    return !!this.source && this.source.jobSummary;
  }
  get responsibilites(): string[] {
    if (!!this.jobSummary) {
      return this.jobSummary
        .split(/[.•➢]/)
        .filter((summary: string) => !!summary.trim())
        .map((summary) => summary.trim().concat('.'));
    } else {
      return [];
    }
  }

  get jobLocation(): LocationInfo {
    return !!this.source && this.source.jobLocation;
  }
}
